
import {SET_SELECTED_GUILD} from 'constants/action-types.js';
import {SET_IS_MANAGING_GUILDS} from 'constants/action-types.js';

let initialState = {
    selectedGuild: undefined,
    isManaging: undefined,
};

const guildsReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_SELECTED_GUILD:
        return {
            ... state,
            selectedGuild: action.payload,
        };
    case SET_IS_MANAGING_GUILDS:
        return {
            ... state,
            isManaging: action.payload
        };
    default:
        return state;
    }
};

export default guildsReducer;
